import { RobotApi } from 'api/RobotApi'
import clsx from 'clsx'
import { Button } from 'components/Button/Button'
import ConfirmDialog from 'components/ConfirmDialog/ConfirmDialog'
import { ReactComponent as FacilitySvg } from 'images/icons/facility.svg'
import { ReactComponent as FirmwareUpdateSvg } from 'images/icons/firmware_update.svg'
import { ReactComponent as MissionPlaySvg } from 'images/icons/mission_play.svg'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectRobot } from 'store/selectors/robot'
import store from 'store/store'
import { robotThunks } from 'store/thunks/robot'
import { ROBOT_MODES } from 'utils/constants'

import style from './Service.module.css'

const noop = () => undefined

const AsbisServiceControl = () => {
  const { t } = useTranslation()
  const robot = useSelector(selectRobot)
  const [confirmOpen, setConfirmOpen] = useState(false)
  const [busy, setBusy] = useState(false)

  const activeMode = robot.robotInfo?.activeMode
  const isRunning = activeMode === ROBOT_MODES.MODE_AUTOMATIC
  const action: 'launch' | 'cancel' = isRunning ? 'cancel' : 'launch'
  const buttonLabel = isRunning ? 'Cancel task' : 'Launch task'
  const confirmTitle = isRunning ? 'Cancel task' : 'Launch task'
  const confirmMessage = isRunning ? 'Send cancel command to the robot?' : 'Send launch command to the robot?'

  const handleConfirm = async () => {
    if (robot.robotInfo?.id == null) return
    setBusy(true)
    try {
      await RobotApi.asbisTask(robot.robotInfo.id, action)
      await store.dispatch(robotThunks.fetchRobot(robot.robotInfo.id))
    } finally {
      setBusy(false)
      setConfirmOpen(false)
    }
  }

  return (
    <div className={style.root}>
      <div className={style.tableHeaderRow}>
        <div className={style.centered}>Maintenance Tasks</div>
      </div>

      <div className={style.tableRow}>
        <div className={style.centered}>
          <MissionPlaySvg />
        </div>
        <div className={clsx(style.chip, style.centered, style.locked)}>
          <Button.Standart className={style.button} disabled={busy} onClick={() => setConfirmOpen(true)}>
            {buttonLabel}
          </Button.Standart>
        </div>
        <div className={clsx(style.chip, style.centered, style.locked)} />
      </div>

      <div className={style.tableRow}>
        <div className={style.centered}>
          <FacilitySvg />
        </div>
        <div className={clsx(style.chip, style.centered, style.locked)}>
          <Button.Standart className={style.button} onClick={noop}>
            {t('robot.button_switch_facility')}
          </Button.Standart>
        </div>
        <div className={clsx(style.chip, style.centered, style.locked)} />
      </div>

      <div className={style.tableHeaderRow}>
        <div className={style.centered}>Service Tasks</div>
      </div>

      <div className={style.tableRow}>
        <div className={style.centered}>
          <FirmwareUpdateSvg />
        </div>
        <div className={clsx(style.chip, style.centered, style.locked)}>
          <Button.Standart className={style.button} onClick={noop}>
            Firmware Update
          </Button.Standart>
        </div>
        <div className={clsx(style.chipSmallFont, style.centered, style.locked)}>Current: 1.6.15</div>
      </div>

      <ConfirmDialog
        isOpen={confirmOpen}
        title={confirmTitle}
        onClose={() => setConfirmOpen(false)}
        onConfirmClick={handleConfirm}
        confirmText={confirmTitle}
      >
        <div>{confirmMessage}</div>
      </ConfirmDialog>
    </div>
  )
}

export default AsbisServiceControl
